import { useMutation, useQueryClient } from "@tanstack/react-query";
import { attemptCreateBrand } from "../../api/OrgApi";
import { useToast } from "../../context/ToastContext";

export const useCreateBrand = () => {
  const queryClient = useQueryClient();
  const { setToastMessage } = useToast();

  return useMutation({
    mutationKey: "create-brand",
    mutationFn: ({ orgID, data }) => attemptCreateBrand(orgID, data),
    onSuccess: (data, variables) => {
      // setToastMessage("Brand Created");
      // Invalidate queries to refetch updated data
      queryClient.invalidateQueries({
        queryKey: ["org-brands", variables.orgID],
      });
    },
    onError: (error) => {
      setToastMessage("Failed to Create Brand");
      console.error("Brand creation error:", error);
    },
  });
};
